import React, { useEffect, useState } from 'react';
import AsyncSelect from 'react-select/async';

// material-ui
import { Box, Button, Card, Grid } from '@mui/material';

import { TCInput, TCSelect, TCSelectStyle } from 'components/TopCourtComponents/Input/TopCourtInput';
import { TCLabel } from 'components/TopCourtComponents/Label/TopCourtLabel';
import { getAdminList } from 'services/adminServices';
import { loadPlayerList } from 'services/playerServices';
import { createVoucher } from 'services/voucherServices';
import { validityMonthOption } from 'constant/constant';
import { useNavigate } from 'react-router';
import moment from 'moment';
import { toastMessage } from 'components/Toast/Toast';

import { getCourtTypes, getPlaces } from 'services/placeServices';
import { getPackageSportCourtType } from 'services/packageSportCourtTypeService';
import { isMerchant } from 'helper/Admin';
import { getUrlCourtCode } from 'helper/Court';

export default function AddVoucher() {

    const [courtTypePackageOption, setCourtTypePackageOption] = useState([])
    const [courtTypeOption, setCourtTypeOption] = useState([])

    const loadCourtType = async () => {
        let { data, error } = await getCourtTypes({
            isActive: true
        })
        if (error) { console.log(error) }
        if (data) {
            let courtType = []
            for (let i = 0; i < data.length; i++) {
                courtType.push({
                    label: data[i].name,
                    value: data[i].courtType
                })
            }
            setCourtTypeOption(courtType)
        }
    }

    useEffect(() => {
        loadCourtType()
        if (isMerchant()) {
            setForm((e) => ({
                ...e,
                validity: validityMonthOption[0],
                smsDetail: "Congratulations! Here's Voucher Code for your Free Session: voucher_code. Redeem it before expired_date. (theballroom.top-court.com)"
            }))
        }
    }, [])

    const [form, setForm] = useState({
        courtType: null,
        courts: [],
        courtIds: [],
        session: null,
        user: null,
        requestBy: null,
        nominal: '',
        expiryDate: null,
        totalVoucher: null,
        isRedeemed: false,
        validity: null,
        smsDetail: "Congratulations! Here's Voucher Code for your Free Session: voucher_code. Redeem it before expired_date. (top-court.com)",
        isDisableSession: false
    })

    const [joiForm, setJoiForm] = useState({
        courtType: form.courtType ? null : "*",
        session: form.session ? null : "*",
        totalVoucher: form.totalVoucher ? null : "*",
        expiryDate: form.expiryDate ? null : "*",
        validity: form.validity ? null : "*"
    })

    const [loading, setLoading] = useState(false)

    const navigation = useNavigate()

    const onChange = (e) => {
        setForm(prev => ({
            ...prev,
            ...e
        }))
        if (e.placeIds && e.placeIds.length > 0) {
            let isMerchantExist = e.placeIds.some(v => v.merchantId != undefined)
            if (isMerchantExist) {
                setForm(prev => ({
                    ...prev,
                    validity: validityMonthOption[0],
                    isDisableSession: true,
                }))
            } else {
                setForm(prev => ({
                    ...prev,
                    isDisableSession: false,
                }))
            }
            loadSportCourtType(e.placeIds)
        } else {
            setForm(prev => ({
                ...prev,
                isDisableSession: false,
            }))
            loadSportCourtType()
        }

    }

    useEffect(() => {
        loadSportCourtType()
    }, [])

    const loadSportCourtType = async (places) => {
        try {
            let placeIds = places ? places.map(v => { return v.value }) : []
            let { data, error } = await getPackageSportCourtType({
                placeIds
            });
            if (error) { console.log(error) }
            setCourtTypePackageOption(data.map(v => {
                return { value: v._id, label: `${v.name}`, data: v }
            }))
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        setJoiForm({
            courtType: form.courtType ? null : "*",
            session: form.session ? null : "*",
            totalVoucher: form.totalVoucher ? null : "*",
            expiryDate: (form.expiryDate && moment(form.expiryDate).endOf('day').toDate() >= new Date()) ? null : "*",
            validity: form.validity ? null : "*"
        })
    }, [form])

    const loadAdminOption = async (input) => {
        if (input.length < 3) {
            return
        }
        try {
            let { data, error } = await getAdminList({
                name: input
            });
            if (error) throw error
            if (data) {
                if (data.length <= 0) return
                return data.map(value => {
                    return {
                        label: value.name,
                        value: value._id
                    }
                })
            }
        } catch (error) {
            console.log(error.message || error)
            return ([])
        }
    }
    const loadUserOption = async (input) => {
        if (input.length < 3) {
            return
        }
        try {
            let { data, error } = await loadPlayerList({
                namePhoneNumber: input.replace("+", ""),
            });
            if (error) throw error
            if (data) {
                if (data.length > 0) {
                    return data.map(value => {
                        return {
                            label: value.name,
                            value: value._id
                        }
                    })
                } else {
                    let user = {
                        label: data.name,
                        value: data._id
                    }
                    return [user]
                }
            }
        } catch (error) {
            console.log(error.message || error)
            return ([])
        }
    }

    const loadPlaceOptions = async (input) => {
        try {
            let { data, error } = await getPlaces({
                name: input
            });
            if (error) throw error
            if (data) {
                console.log('here data info', data)
                if (data.length <= 0) return
                return data.map(value => {
                    return {
                        label: value.name,
                        value: value._id,
                        merchantId: value.merchantId
                    }
                })
            }
        } catch (error) {
            console.log(error.message || error)
            return ([])
        }
    }

    const addVoucher = async () => {
        setLoading(true)
        try {
            let body = {
                ...form
            }
            if (body.user) { body.user = body.user.value }
            if (body.requestBy) { body.requestBy = body.requestBy.value }
            if (body.courtType) {
                body.packageSportCourtTypeId = body.courtType.value
                body.courtType = body.courtType.nameId
            }
            if (body.validity) { body.validity = body.validity.value }
            if (body.placeIds) {
                body.merchantIds = body.placeIds.map(v => { return v.merchantId })
                body.placeIds = body.placeIds.map(v => { return v.value })
            }

            let { data, error } = await createVoucher(body)
            setLoading(false)
            if (error) throw error
            if (data) {
                navigation(`/${getUrlCourtCode()}/vouchers`)
            }
        } catch (error) {
            setLoading(false)
            // Confirm("", error)
            toastMessage(error, {
                toastId: "error-voucher",
                type: "error"
            });
        }
    }

    const checkDisabled = () => {
        return joiForm.courtType || joiForm.session || joiForm.totalVoucher
            || joiForm.expiryDate || joiForm.validity || loading
    }

    return (
        <>
            <Grid item container xs={12} md={12} lg={12}>
                <Grid xs={12} md={6} lg={6} sx={{ p: 1 }}>
                    <Card sx={{ mb: 3 }}>
                        <Box
                            sx={{
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginBottom: 3
                            }}
                        >
                            <Grid container sx={{
                                p: 2
                            }}>
                                {/* <Grid item xs={12} md={12} sx={{ p: 1 }}>
                                    <TCLabel>Request By*</TCLabel>
                                    <AsyncSelect
                                        placeholder={'Select Admin...'}
                                        async
                                        defaultOptions
                                        loadOptions={loadAdminOption}
                                        value={form.requestBy} onChange={(e) => { onChange({ requestBy: e }) }}
                                    />
                                </Grid> */}
                                {/* {
                                    !isMerchant() &&
                                    <Grid item xs={12} md={12} sx={{ p: 1 }}>
                                        <TCLabel style={{ color: 'rgb(133, 133, 133)' }}>Place</TCLabel>
                                        <AsyncSelect
                                            styles={{
                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                ...TCSelectStyle,
                                            }}
                                            placeholder={'Select Places...'}
                                            isClearable
                                            async
                                            defaultOptions
                                            loadOptions={loadPlaceOptions}
                                            isMulti={true}
                                            value={form.placeIds} onChange={(e) => { onChange({ placeIds: e, courtType: null }) }}
                                        />
                                    </Grid>
                                } */}
                                <Grid item xs={12} md={12} sx={{ p: 1 }}>
                                    <TCSelect
                                        label={'Value Pack Category'} showAlert={joiForm.courtType}
                                        value={form.courtType}
                                        onChange={(e) => {
                                            onChange({ courtType: e })
                                        }}
                                        style={{ width: '100%' }}
                                        options={courtTypePackageOption} />
                                </Grid>
                                <Grid item xs={12} md={12} sx={{ p: 1 }}>
                                    <TCInput label={"Session"} value={form.session}
                                        showAlert={joiForm.session}
                                        onChange={(e) => {
                                            let value = e.currentTarget.value.replace(/[^0-9]/g, "")
                                            if (!value) {
                                                onChange({ session: value })
                                                return
                                            }
                                            if (Number(value) <= 0) { value = "" }
                                            onChange({ session: value })
                                        }} />
                                </Grid>
                                <Grid item xs={12} md={12} sx={{ p: 1 }}>
                                    <TCInput label={"Total Voucher"} value={form.totalVoucher}
                                        showAlert={joiForm.totalVoucher}
                                        onChange={(e) => {
                                            let value = e.currentTarget.value.replace(/[^0-9]/g, "")
                                            if (!value) {
                                                onChange({ totalVoucher: value })
                                                return
                                            }
                                            if (Number(value) <= 0) { value = "" }
                                            onChange({ totalVoucher: value })
                                        }} />
                                </Grid>
                                <Grid item xs={12} md={12} sx={{ p: 1 }}>
                                    <TCInput
                                        label={"Expiry Date"}
                                        type={"date"} value={form.expiryDate}
                                        showAlert={joiForm.expiryDate}
                                        onChange={(e) => onChange({ expiryDate: e.currentTarget.value })}
                                        inputProps={
                                            { inputProps: { min: moment().format('YYYY-MM-DD') } }
                                        } />
                                </Grid>
                                <Grid item xs={12} md={12} sx={{ p: 1 }}>
                                    <TCSelect
                                        label={
                                            <TCLabel>{"Session Validity"} {joiForm.validity ? <span style={{ color: '#E35480' }}>{`${joiForm.validity}`}</span> : ""}</TCLabel>
                                        }
                                        value={form.validity}
                                        onChange={(e) => {
                                            onChange({ validity: e })
                                        }}
                                        disabled={(form.isDisableSession || isMerchant()) ? true : false}
                                        options={validityMonthOption}
                                    />
                                </Grid>
                                {
                                    <Grid item xs={12} md={12} sx={{ p: 1 }}>
                                        <TCLabel>Assigned User</TCLabel>
                                        <AsyncSelect
                                            styles={{
                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                ...TCSelectStyle
                                            }}
                                            menuPosition='fixed'
                                            placeholder={'Select User...'}
                                            isClearable
                                            async
                                            defaultOptions
                                            loadOptions={loadUserOption}
                                            value={form.user} onChange={(e) => { onChange({ user: e }) }}
                                        />
                                    </Grid>
                                }
                                {
                                    form.user &&
                                    <Grid item container xs={12} md={12} sx={{ p: 1 }}>
                                        <Grid item xs={12}>
                                            <TCInput type={"textarea"} rows={3} label={"Notify SMS to User"}
                                                value={form.smsDetail}
                                                onChange={(e) => {
                                                    onChange({ smsDetail: e.currentTarget.value })
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                }
                            </Grid>
                            <Grid container direction={"row"} sx={{
                                pl: 3
                            }}>
                                <Button variant="contained"
                                    disabled={checkDisabled()}
                                    onClick={addVoucher}>Create</Button>
                            </Grid>
                        </Box>
                    </Card>
                </Grid>
            </Grid>
        </>
    )
}
